export var commonUtil = (function() {
    var constructFullUrl = function(path, param) {
        // path = "#/search-distributor";
        // path = "http://www.google.com";
        // path = "/content/mecommerce/americas/US/en/signup/signup.html#/search-distributor";
        // path = "/content/mecommerce/americas/US/en/home";
        // path = "/content/mecommerce/americas/US/en/home.html";
        var rv = '';

        if (path) {
            var pattern = /^https?:\/\//i;
            if (pattern.test(path)) {
                rv = path;
            } else {
                // adding the protocol, the serverName, and the port
                var arr = window.location.href.split('/');

                if (path.indexOf('#') === 0) {
                    rv = arr[0] + '//' + arr[2] + window.location.pathname + path;
                } else {
                    // that means the path may be an AEM pathfield
                    rv = arr[0] + '//' + arr[2] + path;

                    // adding the .html if it does NOT exist
                    if (path.toLowerCase().indexOf('.html') === -1) {
                        rv += '.html';
                    }
                }
            }
        }

        // Handling the param (param is in the form of p1=value1&p2=value2
        if (rv && param) {
            if (param.indexOf('?') === -1) {
                param = '?' + param;
            }

            var loc = rv.indexOf('#'); // Get the first occurrence of the hash
            if (loc < 0) {
                rv += param; // append the param at the end because it does not have any hash
            } else {
                rv = rv.substring(0, loc) + param + rv.substring(loc, rv.length);
            }
        }

        return rv;
    };

    var goToPath = function(path) {
        window.location = constructFullUrl(path);
    };

    return {
        constructFullUrl: constructFullUrl,
        goToPath: goToPath
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/common-util.js
// module id = 281
// module chunks = 0